import { jsxs as S, jsx as a } from "react/jsx-runtime";
import { useMemo as N, forwardRef as $e } from "react";
import { c } from "./index.CWkFp9WS.js";
import { d as _ } from "./customParseFormat.VB0eI5Wm.js";
import { O as ae } from "./ODSPickerDropdownItem.nw-WS9Ve.js";
import { l as Ie, F as ve, n as Le, v as xe } from "./floating-ui.react.MkaYL6o7.js";
import { c as oe, d as H, g as Te, e as Ae, f as Re, h as O } from "./ODSDatePicker.utils.Dvmx0txe.js";
import { O as We } from "./ODSDatePickerDay.iq_3GF3r.js";
import { O as u } from "./ODSColumn.B8Qu83P2.js";
import { O as b } from "./ODSRow.Du_e7gfN.js";
import { O as Y } from "./ODSButton.BmQliYzd.js";
import { O as ze } from "./ODSDivider.DGHoVesr.js";
import { u as Ge } from "./scoped-color-scheme.D8FTJTjz.js";
import { O as Ke } from "./ODSText.D6mgyggF.js";
import { O as Ve } from "./ODSLoadingSpinner.qaoMkU-3.js";
import '../assets/ODSDatePickerFlyout.css';const je = (d) => {
  const {
    size: T,
    previousMonthButtonProps: A,
    nextMonthButtonProps: R,
    monthButtonProps: P,
    yearButtonProps: F
  } = d, W = oe(), {
    renderedMonth: m,
    maxDate: g,
    minDate: k,
    view: s,
    setView: $,
    disableFuture: f,
    disablePast: p,
    goToPreviousMonth: I,
    goToNextMonth: v,
    monthSelectionButtonRef: L,
    yearSelectionButtonRef: z,
    locale: D
  } = W, x = N(() => {
    const h = m.subtract(1, "month");
    return !H(h, {
      precision: "month",
      minDate: k,
      maxDate: g,
      disableFuture: f,
      disablePast: p
    }).isValid;
  }, [k, g, f, p, m]), G = N(() => {
    const h = m.add(1, "month");
    return !H(h, {
      precision: "month",
      minDate: k,
      maxDate: g,
      disableFuture: f,
      disablePast: p
    }).isValid;
  }, [k, g, f, p, m]);
  return /* @__PURE__ */ S(
    u,
    {
      className: c(
        "ODSDatePickerFlyout-DateAndYearPicker",
        `ODSDatePickerFlyout-DateAndYearPicker--size-${T}`,
        `ODSDatePickerFlyout-DateAndYearPicker--type-${s}`
      ),
      children: [
        /* @__PURE__ */ S(b, { className: "ODSDatePickerFlyout-WrapContainer", children: [
          /* @__PURE__ */ S(b, { className: "ODSDatePickerFlyout-CalendarDropdownContainer", children: [
            (s === "date" || s === "month") && /* @__PURE__ */ a(
              Y,
              {
                buttonIcon: `sort-indicator-${s === "month" ? "up" : "down"}-type-standard`,
                buttonType: "standard",
                label: m.locale(D).format("MMM"),
                leftIcon: !1,
                rightIcon: !0,
                size: "small",
                variant: "ghost",
                onClick: () => $(s === "month" ? "date" : "month"),
                ...P,
                "aria-label": `${m.locale(D).format("MMMM")} - ${(P == null ? void 0 : P["aria-label"]) ?? "Switch to month view"} `,
                ref: L
              }
            ),
            (s === "date" || s === "year") && /* @__PURE__ */ a(
              Y,
              {
                buttonIcon: `sort-indicator-${s === "year" ? "up" : "down"}-type-standard`,
                buttonType: "standard",
                label: m.locale(D).format("YYYY"),
                leftIcon: !1,
                rightIcon: !0,
                size: "small",
                variant: "ghost",
                onClick: () => $(s === "year" ? "date" : "year"),
                "aria-live": "polite",
                ...F,
                "aria-label": `${m.locale(D).format("YYYY")} - ${(F == null ? void 0 : F["aria-label"]) ?? "Switch to year view"}`,
                ref: z
              }
            )
          ] }),
          s === "date" && /* @__PURE__ */ S(b, { className: "ODSDatePickerFlyout-CalendarNavigationContainer", children: [
            /* @__PURE__ */ a(
              Y,
              {
                buttonIcon: "navigation-left-type-standard",
                buttonType: "iconOnly",
                size: "small",
                variant: "ghost",
                onClick: () => I("previousMonth"),
                disabled: x,
                "aria-label": "Go to previous month",
                ...A
              }
            ),
            /* @__PURE__ */ a(
              Y,
              {
                buttonIcon: "navigation-right-type-standard",
                buttonType: "iconOnly",
                size: "small",
                variant: "ghost",
                onClick: () => v("nextMonth"),
                disabled: G,
                "aria-label": "Go to next month",
                ...R
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ a(
          ze,
          {
            className: "ODSDatePickerFlyout-OdsDivider",
            inset: !1,
            spacing: !1,
            type: "horizontal"
          }
        )
      ]
    }
  );
}, Ee = () => /* @__PURE__ */ a(u, { className: "ODSDatePickerFlyout-loadingSlot", children: /* @__PURE__ */ a(Ve, {}) }), Be = $e(
  ({
    size: d = "large",
    className: T,
    previousMonthButtonProps: A,
    nextMonthButtonProps: R,
    monthButtonProps: P,
    yearButtonProps: F,
    okButtonProps: W,
    cancelButtonProps: m,
    "aria-label": g,
    format: k = "DD/MM/YYYY",
    loading: s = !1,
    loadingSlot: $,
    //callbacks
    onChange: f,
    onError: p,
    onOk: I,
    onCancel: v,
    ...L
  }, z) => {
    const D = oe(), {
      setOpen: x,
      activeDate: G,
      maxDate: h,
      minDate: K,
      selectedDate: M,
      selectDate: U,
      getItemProps: V,
      activeDateIndex: j,
      activeMonthIndex: re,
      activeYearIndex: ie,
      calendarItems: n,
      listRef: le,
      yearListRef: ne,
      monthListRef: se,
      view: i,
      setView: q,
      selectMonth: ce,
      selectYear: De,
      isMounted: de,
      menuStyles: me,
      goToPreviousMonth: J,
      goToNextMonth: Q,
      open: ye,
      disablePast: w,
      disableFuture: C,
      monthSelectionButtonRef: E,
      yearSelectionButtonRef: B,
      dateValidator: ue,
      locale: y
    } = D, ke = N(() => Te(y), [y]), fe = N(
      () => Ae(C, w, y),
      [w, C, y]
    ), pe = N(
      () => Re(
        _(K).year(),
        _(h).year(),
        C,
        w,
        y
      ),
      [C, w, K, h, y]
    ), he = Ie([D.refs.setFloating, z]), { colorScheme: Oe, colorMode: Se } = Ge(
      D.refs.reference,
      [ye]
    ), Pe = (t, e, r) => {
      const o = ((n == null ? void 0 : n.length) ?? 0) - 1;
      switch (t ? t == null ? void 0 : t.key : "") {
        case "Enter":
          U(e);
          break;
        case "ArrowUp":
          r < O && (J("calendarNavigation"), t == null || t.preventDefault());
          break;
        case "ArrowDown":
          o > -1 && r > o - O && (Q("calendarNavigation"), t == null || t.preventDefault());
          break;
        case "ArrowLeft":
          r === 0 && (J("calendarNavigation"), t == null || t.preventDefault());
          break;
        case "ArrowRight":
          n != null && n.length && r === o && (Q("calendarNavigation"), t == null || t.preventDefault());
          break;
      }
    }, X = (t) => {
      var e;
      ce(t), q("date"), (e = E == null ? void 0 : E.current) == null || e.focus();
    }, Z = (t) => {
      var e;
      De(t), q("date"), (e = B == null ? void 0 : B.current) == null || e.focus();
    }, Fe = (t) => {
      U(t);
      const e = t.locale(y).format(k), { isValid: r, error: o } = H(t, {
        precision: "date",
        disableFuture: C,
        disablePast: w,
        dateValidator: ue,
        minDate: K,
        maxDate: h
      }), l = (e == null ? void 0 : e.length) > 0 ? t.toDate() : null;
      f && f(l, e, o), !r && (e == null ? void 0 : e.length) === k.length && p && p(l, e, o);
    }, ge = $ ?? /* @__PURE__ */ a(Ee, {}), Me = () => {
      x(!1), I && I();
    }, Ye = () => {
      x(!1), v && v();
    };
    return de && /* @__PURE__ */ a(ve, { children: /* @__PURE__ */ a(
      Le,
      {
        context: D.context,
        initialFocus: 4,
        children: /* @__PURE__ */ S(
          u,
          {
            ...L,
            className: c(
              "ODSDatePickerFlyout",
              `ODSDatePickerFlyout--type-${i}`,
              `ODSDatePickerFlyout--size-${d}`,
              T
            ),
            style: {
              ...D.context.floatingStyles,
              ...me
            },
            ...D.getFloatingProps({
              ...L,
              "aria-orientation": void 0,
              //a11y request, aria-orientation not allowed on role=dialog
              "aria-label": g
            }),
            "data-scheme": Oe,
            "data-mode": Se,
            ref: he,
            children: [
              /* @__PURE__ */ a(
                je,
                {
                  size: d,
                  previousMonthButtonProps: A,
                  nextMonthButtonProps: R,
                  monthButtonProps: P,
                  yearButtonProps: F
                }
              ),
              i === "month" && /* @__PURE__ */ a(
                u,
                {
                  className: c(
                    "ODSDatePickerFlyout-ScrollListContainer",
                    `ODSDatePickerFlyout-ScrollListContainer--type-${i}`,
                    `ODSDatePickerFlyout-ScrollListContainer--size-${d}`
                  ),
                  role: "list",
                  "aria-live": "polite",
                  children: fe.map(({ label: t, month: e, disabled: r }, o) => /* @__PURE__ */ a(
                    ae,
                    {
                      className: c(
                        "ODSDatePickerFlyout-OdsPickerDropdownItem",
                        `ODSDatePickerFlyout-OdsPickerDropdownItem--type-${i}`,
                        {
                          "ODSDatePickerFlyout-OdsPickerDropdownItem--disabled": r
                        }
                      ),
                      label: t,
                      selected: M && M.month() === e,
                      tabIndex: re === o ? 0 : -1,
                      ref: (l) => {
                        se.current[o] = l;
                      },
                      ...V({
                        onClick: () => {
                          r || X(e);
                        },
                        onKeyDown: (l) => {
                          l.key === "Enter" && (l.preventDefault(), r || X(e));
                        },
                        disabled: r,
                        role: "listitem"
                      })
                    },
                    e
                  ))
                }
              ),
              i === "year" && /* @__PURE__ */ a(
                u,
                {
                  className: c(
                    "ODSDatePickerFlyout-ScrollListContainer",
                    `ODSDatePickerFlyout-ScrollListContainer--type-${i}`,
                    `ODSDatePickerFlyout-ScrollListContainer--size-${d}`
                  ),
                  role: "list",
                  "aria-live": "polite",
                  children: pe.map(({ label: t, year: e, disabled: r }, o) => /* @__PURE__ */ a(
                    ae,
                    {
                      className: c(
                        "ODSDatePickerFlyout-OdsPickerDropdownItem",
                        `ODSDatePickerFlyout-OdsPickerDropdownItem--type-${i}`,
                        {
                          "ODSDatePickerFlyout-OdsPickerDropdownItem--disabled": r
                        }
                      ),
                      label: t,
                      selected: M && M.year() === e,
                      tabIndex: ie === o ? 0 : -1,
                      ref: (l) => {
                        ne.current[o] = l;
                      },
                      ...V({
                        onClick: () => {
                          r || Z(e);
                        },
                        onKeyDown: (l) => {
                          l.key === "Enter" && (l.preventDefault(), r || Z(e));
                        },
                        disabled: r,
                        role: "listitem"
                      })
                    },
                    e
                  ))
                }
              ),
              i === "date" && /* @__PURE__ */ S(
                b,
                {
                  className: c(
                    "ODSDatePickerFlyout-WeekdaysListContainer",
                    `ODSDatePickerFlyout-WeekdaysListContainer--size-${d}`,
                    `ODSDatePickerFlyout-WeekdaysListContainer--type-${i}`
                  ),
                  children: [
                    /* @__PURE__ */ a("span", { className: "sr-only", role: "status", "aria-live": "polite", children: _(G).locale(y).format("MMMM YYYY") }),
                    ke.map(({ label: t, abbr: e }) => /* @__PURE__ */ a(
                      u,
                      {
                        className: c(
                          "ODSDatePickerFlyout-Weekday",
                          `ODSDatePickerFlyout-Weekday--type-${i}`,
                          `ODSDatePickerFlyout-Weekday--size-${d}`
                        ),
                        children: /* @__PURE__ */ a(
                          Ke,
                          {
                            as: "span",
                            className: c(
                              "ODSDatePickerFlyout-Label",
                              `ODSDatePickerFlyout-Label--type-${i}`
                            ),
                            abbr: e,
                            children: t
                          }
                        )
                      },
                      t
                    ))
                  ]
                }
              ),
              i === "date" && /* @__PURE__ */ a(
                u,
                {
                  className: c(
                    "ODSDatePickerFlyout-DateGrid",
                    `ODSDatePickerFlyout-DateGrid--type-${i}`,
                    `ODSDatePickerFlyout-DateGrid--size-${d}`
                  ),
                  role: "grid",
                  "aria-activedescendant": n && j ? n[j].date.format("DDMMYYYY") : void 0,
                  "aria-live": "polite",
                  children: /* @__PURE__ */ a(u, { className: "ODSDatePickerFlyout-DateGridInner", children: s ? ge : /* @__PURE__ */ a(xe, { elementsRef: le, children: Array.from({
                    length: (n ? n.length : 0) / O
                  }).map((t, e) => {
                    const r = (n == null ? void 0 : n.slice(
                      e * O,
                      e * O + O
                    )) ?? [];
                    return /* @__PURE__ */ a(
                      b,
                      {
                        className: c(
                          "ODSDatePickerFlyout-RowListContainer",
                          `ODSDatePickerFlyout-RowListContainer--type-${i}`
                        ),
                        role: "row",
                        "aria-rowindex": e + 1,
                        children: r.map(
                          ({
                            date: o,
                            label: l,
                            isCurrentMonth: be,
                            isToday: we,
                            disabled: Ce
                          }, ee) => {
                            const te = e * O + ee;
                            return /* @__PURE__ */ a(
                              We,
                              {
                                id: o.format("DDMMYYYY"),
                                "data-date": o.format("DD/MM/YYYY"),
                                size: d,
                                label: l,
                                inActiveMonth: be,
                                selected: M && o.isSame(M, "date"),
                                showToday: we,
                                autoFocus: j === te,
                                ...V({
                                  onClick: () => Fe(o),
                                  onKeyDown: (Ne) => {
                                    Pe(
                                      Ne,
                                      o,
                                      te
                                    );
                                  },
                                  role: "gridcell",
                                  "aria-colindex": ee + 1,
                                  disabled: Ce,
                                  "aria-label": o.locale(y).format("dddd, MMMM DD YYYY")
                                })
                              },
                              o.format("DD/MM/YYYY")
                            );
                          }
                        )
                      },
                      e
                    );
                  }) }) })
                }
              ),
              i === "date" && /* @__PURE__ */ S(
                b,
                {
                  className: c(
                    "ODSDatePickerFlyout-ActionFrame",
                    `ODSDatePickerFlyout-ActionFrame--type-${i}`
                  ),
                  children: [
                    /* @__PURE__ */ a(
                      Y,
                      {
                        buttonType: "standard",
                        label: "Cancel",
                        leftIcon: !1,
                        rightIcon: !1,
                        size: "small",
                        variant: "ghost",
                        onClick: Ye,
                        ...m
                      }
                    ),
                    /* @__PURE__ */ a(
                      Y,
                      {
                        buttonType: "standard",
                        label: "Ok",
                        leftIcon: !1,
                        rightIcon: !1,
                        size: "small",
                        variant: "ghost",
                        onClick: Me,
                        ...W
                      }
                    )
                  ]
                }
              )
            ]
          }
        )
      }
    ) });
  }
);
Be.displayName = "ODSDatePickerFlyout";
export {
  Be as O
};
//# sourceMappingURL=ODSDatePickerFlyout.CoG54o6I.js.map
